import React from 'react'

const Badge = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 22 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.03027 15.1279L11.8481 16.4189L8.87896 27.4999L7.11551 24.4455L4.06111 26.209L7.03027 15.1279Z"
      fill="white"
      stroke="#353F45"
      strokeWidth="1.24615"
      strokeLinejoin="round"
    />
    <path
      d="M14.7676 15.1279L9.94973 16.4189L12.9189 27.4999L14.6823 24.4455L17.7367 26.209L14.7676 15.1279Z"
      fill="#353F45"
      stroke="#353F45"
      strokeWidth="1.24615"
      strokeLinejoin="round"
    />
    <path
      d="M3.53245 6.82678L1.06934 8.30465L2.5472 10.7678L1.06934 13.4772L3.53245 15.2014V18.4034L6.48819 18.1571L8.21237 21.1128L10.9218 19.3887L13.6312 21.1128L15.1091 18.1571H18.3111L18.0648 15.2014L20.7743 13.7235L19.2964 10.7678L21.0206 8.30465L18.0648 6.82678L18.3111 3.62474L15.1091 3.87105L13.6312 1.16162L10.9218 2.63949L8.21237 1.16162L6.48819 3.62474H3.53245V6.82678Z"
      fill="white"
      stroke="#353F45"
      strokeWidth="1.24615"
      strokeLinejoin="round"
    />
    <circle
      cx="11.0447"
      cy="11.138"
      r="6.48415"
      fill="white"
      stroke="#353F45"
      strokeWidth="0.830769"
    />
    <path
      d="M11.0443 7.65796L11.8256 10.0625H14.3539L12.3085 11.5486L13.0897 13.9531L11.0443 12.467L8.9989 13.9531L9.78018 11.5486L7.73477 10.0625H10.263L11.0443 7.65796Z"
      fill="#353F45"
      stroke="#353F45"
      strokeWidth="0.830769"
      strokeLinejoin="round"
    />
  </svg>
)

export default Badge
